"use client";
import { useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { ChevronDown, ChevronRight } from "lucide-react";

const SidebarLink = ({ post }: any) => {
  const pathUrl = usePathname() ?? "";
  const lang = pathUrl.split("/")[1] || "en";
  const lessonHref = (slug: string) => `/${lang}/docs/${slug}`;

  // chapter title is the first element (string)
  const chapter_title = post[0];
  // lessons array is everything after
  const posts = post.slice(1).sort((a: any, b: any) => a.lesson - b.lesson);;

  // toggle state for open/close; the chapter holding the current lesson starts open
  const [isOpen, setIsOpen] = useState(() =>
    posts.some((_post: any) => pathUrl === lessonHref(_post?.slug)),
  );

  return (
    <li className="block">
      {/* Chapter Header */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between py-2.5 px-3 font-semibold text-left rounded-md hover:bg-white/5 transition-all"
      >
        <span>{chapter_title}</span>
        {isOpen ? (
          <ChevronDown size={16} className="ml-2" />
        ) : (
          <ChevronRight size={16} className="ml-2" />
        )}
      </button>

      {/* Lessons stay in the HTML when closed so crawlers can follow them */}
      <ul
        className={`ml-4 mt-2 space-y-1 border-l border-white/10 pl-3 ${isOpen ? "" : "hidden"}`}
      >
        {posts.map((_post: any, key: number) => (
          <li key={key}>
            <Link
              href={lessonHref(_post?.slug)}
              className={`font-medium py-2 px-3 rounded-md flex w-full duration-300 hover:text-white hover:bg-white/10 ${
                pathUrl === lessonHref(_post?.slug) ? "text-white bg-white/10" : ""
              }`}
            >
              {_post?.title}
            </Link>
          </li>
        ))}
      </ul>
    </li>
  );
};

export default SidebarLink;
